import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import './Layout.css';

// 路由到标题映射
const routeTitles: Record<string, { group: string; title: string }> = {
  '/apps': { group: '工作台', title: '企业应用' },
  '/tools': { group: '工作台', title: '超级工具' },
  '/wins': { group: '工作台', title: '战果发布' },
  '/knowledge': { group: '资产', title: '企业知识库' },
  '/connectors': { group: '资产', title: '连接器' },
  '/org': { group: '管理', title: '部门人员与权限' },
  '/tenants': { group: '管理', title: '租户管理' },
};

function SidebarToggleIcon() {
  return (
    <svg className="icon" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.45" strokeLinecap="round" strokeLinejoin="round" width="18" height="18">
      <path d="M2 3h16v14H2V3Zm5 0v14"/>
    </svg>
  );
}

export function Layout() {
  const location = useLocation();
  
  // 获取当前路由的标题信息
  const getRouteInfo = () => {
    // 处理租户前缀路由
    const pathParts = location.pathname.split('/').filter(Boolean);
    let basePath = location.pathname;
    
    // 如果第一部分不是已知路由，则可能是租户前缀
    if (pathParts.length >= 2 && !routeTitles['/' + pathParts[0]]) {
      basePath = '/' + pathParts.slice(1).join('/');
    }
    
    return routeTitles[basePath] || { group: '工作台', title: '企业应用' };
  };
  
  const routeInfo = getRouteInfo();

  const handleSidebarToggle = () => {
    const appShell = document.querySelector('.app-shell');
    if (!appShell) return;
    
    // 移动端使用滑出效果
    if (window.innerWidth <= 760) {
      appShell.classList.toggle('sidebar-open');
    } else {
      // 桌面端使用收起效果
      appShell.classList.toggle('sidebar-collapsed');
      document.body.classList.toggle('sidebar-collapsed');
    }
  };

  return (
    <div className="app-shell">
      <div id="sidebarHost">
        <Sidebar />
      </div>
      <button 
        className="sidebar-scrim" 
        aria-label="收起导航" 
        onClick={() => {
          const appShell = document.querySelector('.app-shell');
          appShell?.classList.remove('sidebar-open');
        }}
        tabIndex={-1}
      />
      <div className="workspace">
        <header className="topbar">
          <button 
            className="btn btn-icon sidebar-toggle" 
            onClick={handleSidebarToggle}
            aria-label="切换侧栏" 
            title="切换侧栏"
          >
            <SidebarToggleIcon />
          </button>
          <nav id="breadcrumbs" className="breadcrumbs" aria-label="页面位置">
            <span className="crumb">{routeInfo.group}</span>
            <span className="crumb-divider">/</span>
            <button className="crumb-button" aria-current="page">
              {routeInfo.title}
            </button>
          </nav>
        </header>
        <main id="pageMain" tabIndex={-1}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
